<!-- El formGroup se repite aquí porque formControlName no cruza el límite del componente hijo. -->
<div
  class="form-row"
  *ngIf="ctx.isCopDeclaredCashin"
  [formGroup]="ctx.declarationCashinForm"
>
  <div class="filter-column">
    <div class="form-item" *ngIf="ctx.transactionTypes.length">
      <label>Tipo de transacción</label>
      <div class="account-type-picker">
        <div
          *ngFor="let type of ctx.transactionTypes"
          class="accu-type"
          [class.selected]="
            ctx.declarationCashinForm.controls.transaction_type.value ===
            type.id
          "
          (click)="ctx.setDeclaredTransactionType(type.id)"
        >
          {{ type.id }}
        </div>
      </div>
    </div>

    <div class="form-item">
      <label for="cop_cashin_firstname">Nombres</label>
      <input
        id="cop_cashin_firstname"
        type="text"
        placeholder="Ingresa los nombres"
        formControlName="firstname"
        pInputText
        class="id-input-filter"
      />
    </div>
  </div>

  <div class="filter-column">
    <div class="form-item">
      <label for="cop_cashin_lastname">Apellidos</label>
      <input
        id="cop_cashin_lastname"
        type="text"
        placeholder="Ingresa los apellidos"
        formControlName="lastname"
        pInputText
        class="id-input-filter"
      />
    </div>

    <div class="form-item">
      <label for="cop_cashin_document">
        Documento de identidad <span class="required">*</span>
      </label>
      <input
        id="cop_cashin_document"
        type="text"
        placeholder="ej. CC-123456789"
        formControlName="id_number"
        pInputText
        class="id-input-filter"
      />
    </div>
  </div>

  <div class="filter-column">
    <div class="form-item">
      <label for="cop_cashin_company_id">Banco de origen</label>
      <p-dropdown
        id="cop_cashin_company_id"
        placeholder="Elige el banco"
        formControlName="company_id"
        [options]="ctx.getBanks()"
        optionLabel="shortname"
        [filter]="true"
        filterBy="shortname"
        (onChange)="ctx.pickVesBank($event)"
        appendTo="body"
      />
    </div>

    <div class="form-item">
      <label for="cop_cashin_account_number">Cuenta origen</label>
      <input
        id="cop_cashin_account_number"
        type="tel"
        placeholder="Ingresa la cuenta origen"
        formControlName="account_number"
        pInputText
        class="id-input-filter"
      />
    </div>
  </div>
</div>
